const guestLoginSetMpinMapper = (response) => {
    if (response.data)
        return {
            status: true,
            createDate: response.data.crtDt,
            message: response.data.msg,
        };
    return {
        status: false,
        createDate: "",
        message: "",
    };
};
export default guestLoginSetMpinMapper;
